import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { Gift } from '@interfaces';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService): GridSetup<Gift> {

	return {
		rowName: { singular: 'Gift', plural: 'Gifts' },
		getRowKey: row => '' + row.giftId,
		stateKey: 'devo-donors-gifts-grid',
		actions: getActions(),
		buttons: [],
		columns: getColumns(util),
	}
}
